import axiosLib from 'axios'

const axiosWithPostUrlEncoded = axiosLib.create({
  timeout: 30000,
})

const axios = axiosLib.create({
  timeout: 30000,
})

axiosWithPostUrlEncoded.interceptors.request.use(config => {
  if (config.method === 'post') {
    config.headers['content-type'] = 'application/x-www-form-urlencoded'
  }
  return config
})

export { axiosWithPostUrlEncoded, axios }
